// extracted by mini-css-extract-plugin
export default {"errorMessage":"SearchButton_errorMessage__LcJ5Z"};